import React, { FC } from 'react';
import Styles from './styles';
import { IPagination1 } from './params';
import { IPaginationData } from '../index';

const Pagination: FC<{ config: IPagination1; paginationData: IPaginationData }> = ({
  config,
  paginationData: { currentPage, totalPages, baseUrl },
}) => {
  const buttons = [];

  const showFirstLast = totalPages > 7;
  const isFirstDisabled = currentPage < 3;
  const isLastDisabled = currentPage > totalPages - 2;

  let paginationRange = 3;
  if (totalPages <= 7) paginationRange = 7;
  else if (currentPage <= 4 || currentPage >= totalPages - 3) paginationRange = 5;

  let rangeStart = currentPage - Math.ceil(paginationRange / 2) + 1;
  if (showFirstLast && totalPages - currentPage === 3) rangeStart = rangeStart + 1;
  if (rangeStart + paginationRange > totalPages) rangeStart = totalPages - paginationRange + 1;
  if (rangeStart < 1 || currentPage <= 4) rangeStart = 1;

  let rangeStop = rangeStart + paginationRange - 1;
  if (rangeStop > totalPages) rangeStop = totalPages;

  for (let index = rangeStart; index <= rangeStop; index += 1) {
    buttons.push(
      <>
        {index === currentPage ? (
          <div key={`page${index}`} className="pagination-button active">
            {index}
          </div>
        ) : (
          <a key={`page${index}`} href={`${baseUrl}${index === 1 ? '' : `/${index}`}`} className="pagination-button">
            {index}
          </a>
        )}
      </>,
    );
  }

  return (
    <Styles $config={config}>
      <div className="pagination">
        {currentPage > 4 && showFirstLast && (
          <>
            <a href={baseUrl} className={`pagination-button first ${isFirstDisabled ? 'disabled' : ''}`}>
              1
            </a>
            <div className="pagination-button between">...</div>
          </>
        )}
        {buttons.map((button, index) => (
          <React.Fragment key={index}>{button}</React.Fragment>
        ))}
        {currentPage < totalPages - 3 && showFirstLast && (
          <>
            <div className="pagination-button between">...</div>
            <a
              href={`${baseUrl}/${totalPages}`}
              className={`pagination-button last ${isLastDisabled ? 'disabled' : ''}`}
            >
              {totalPages}
            </a>
          </>
        )}
      </div>
    </Styles>
  );
};

export default Pagination;
